import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { saveHighFrequency, updateHighFrequency } from './edit-project-actions';
import { useParams } from 'react-router-dom';

const EditProjectHighFrequency = (props) => {

    const state = useSelector(state => state.pages.editProject)
    const highFrequency = state.highFrequency
    const { project } = useParams()

    return (
        <form onSubmit={e => saveHighFrequency(e, project)}>
            <div className="grid gap-4  ">
                <div className=" border-b pb-4 bg-gray-100 p-4">
                    <p className="text-md text-gray-800">High Frequency is a goback monitoring tool that allows you to detect multiple updates within a short time frame and trigger alerts to optimize your collections and applications. This is a project level configuration, it will be used to trigger alerts for all collections in the project</p>
                </div>
                <div className="grid grid-cols-1 gap-4 p-4">
                    <div className="grid gap-4">
                        <div className="flex flex-row gap-4 items-center" >
                            <FormControl required variant="outlined" size="large" fullWidth={false}>
                                <TextField
                                    required
                                    className="w-[300px]"
                                    size="medium"
                                    type="number"
                                    name="maxUpdates"
                                    label="Max Updates per time window"
                                    value={highFrequency.maxUpdates}
                                    onChange={updateHighFrequency}
                                />
                            </FormControl>
                            <Tooltip title="The number of updates within a time window that trigger an alert">
                                <HelpOutlineIcon />
                            </Tooltip>

                        </div>
                        <div className="flex gap-4">
                            <FormControl required variant="outlined" size="large" fullWidth={false}>
                                <TextField
                                    required
                                    size="medium"
                                    className="w-[300px]"
                                    type="number"
                                    name="timeWindow"
                                    label="Time Window"
                                    value={highFrequency.timeWindow}
                                    onChange={updateHighFrequency}
                                />
                            </FormControl>
                            <div className="flex flex-row gap-4 items-center" >
                                <FormControl size="medium" required>
                                    <InputLabel id="incident-label">Time Window Unit</InputLabel>
                                    <Select
                                        required
                                        label="Time Window Unit"
                                        className="w-48"
                                        name="timeWindowUnit"
                                        placeholder='Time Window Unit'
                                        value={highFrequency.timeWindowUnit}
                                        onChange={updateHighFrequency}
                                    >
                                        <MenuItem value="MILLISECONDS" disabled><em>SELECT</em></MenuItem>
                                        <MenuItem value="MILLISECONDS">MILLISECONDS</MenuItem>
                                        <MenuItem value="SECONDS">SECONDS</MenuItem>
                                        <MenuItem value="MINUTES">MINUTES</MenuItem>
                                    </Select>
                                </FormControl>
                                <Tooltip title="The time window for evaluating the number of updates">
                                    <HelpOutlineIcon />
                                </Tooltip>
                            </div>


                        </div>

                        <div className="flex gap-4">
                            <FormControl required variant="outlined" size="large" fullWidth={false}>
                                <TextField
                                    required
                                    size="medium"
                                    className="w-[300px]"
                                    type="number"
                                    name="cooldown"
                                    label="Cooldown"
                                    value={highFrequency.cooldown}
                                    onChange={updateHighFrequency}
                                />
                            </FormControl>
                            <div className="flex flex-row gap-4 items-center" >
                                <FormControl size="medium" required>
                                    <InputLabel id="incident-label">Cooldown Unit</InputLabel>
                                    <Select
                                        required
                                        label="Cooldown Unit"
                                        className="w-48"
                                        name="cooldownUnit"
                                        placeholder='Cooldown Unit'
                                        value={highFrequency.cooldownUnit}
                                        onChange={updateHighFrequency}
                                    >
                                        <MenuItem value="MILLISECONDS" disabled><em>SELECT</em></MenuItem>
                                        <MenuItem value="MILLISECONDS">MILLISECONDS</MenuItem>
                                        <MenuItem value="SECONDS">SECONDS</MenuItem>
                                        <MenuItem value="MINUTES">MINUTES</MenuItem>
                                    </Select>
                                </FormControl>
                                <Tooltip title="The cooldown period prevents multiple alerts from being triggered within a short time frame">
                                    <HelpOutlineIcon />
                                </Tooltip>
                            </div>
                        </div>

                        <div className="flex flex-row gap-4 pl-1">
                            <FormControl variant="outlined" size="small" fullWidth={false}>
                                <FormControlLabel
                                    labelPlacement="end"
                                    label="Enabled"
                                    control={
                                        <Checkbox
                                            id="enabled"
                                            name="enabled"
                                            className=""
                                            checked={highFrequency.enabled}
                                            onChange={updateHighFrequency}
                                        />
                                    }
                                />
                                <FormHelperText>This configuration determines if the alert is enabled or disabled</FormHelperText>
                            </FormControl>
                        </div>

                        <div>
                            <p>This configuration triggers an alert when <span className="text-green-500">{highFrequency.maxUpdates}</span> updates are made within a <span className="text-green-500">{highFrequency.timeWindow} {highFrequency.timeWindowUnit}</span> window, with a <span className="text-green-500">{highFrequency.cooldown} {highFrequency.cooldownUnit}</span> cooldown</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-4 text-right bg-gray-100 border-t border-gray-300">
                <Button variant="contained" type='submit' className="text-dark-500" >SAVE</Button>
            </div>
        </form>
    )
}

export default EditProjectHighFrequency;


// private Long cooldown;
// private TimeUnit cooldownUnit;